<h3 class="risk-header">RISK DISCLOSURES ON DERIVATIVES</h3>
<ul>
    <div>
        <li class="list-items"> 9 out of 10 individual traders in equity Futures and Options Segment, incurred net
            losses.
        </li>
        <li class="list-items"> On an average, loss makers registered net trading loss close to Rs. 50,000. </li>
        <li class="list-items"> Over and above the net trading losses incurred, loss makers expended an additional 28%
            of net
            trading
            losses as transaction costs.</li>
        <li class="list-items"> Those making net trading profits, incurred between 15% to 50 % of such profits as
            transaction
            cost. </li>
    </div>
</ul>

<p class="risk-text">Source:
    <a href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html"
        target="_blank" class="sebi-link">SEBI study</a>
    dated January 25, 2023 on “Analysis of Profit and Loss of Individual Traders dealing in equity Futures
    and Options (FO) Segment”,
    wherein Aggregate Level findings are based on annual Profit/ Loss incurred by individual traders in equity F&O
    during FY 2021-22."
</p>
<p class="text-left font-bold">* I understand the risks associated with derivative trading.</p>

<div class="flex-centered-container-hr">
    <button type="submit" mat-flat-button class="button-container new-submit-button fg-white" (click)="popupAccepted()">Accept</button>
</div>
